/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnFormalizedZipRequestDto } from '../models/UnFormalizedZipRequestDto';
import type { UnFormalizedZipResponseDto } from '../models/UnFormalizedZipResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UnFormalizedZipControllerService {

    /**
     * @param id
     * @returns UnFormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static findUnFormalizedZipById(
        id: number,
    ): CancelablePromise<UnFormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/unformalized-zips/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns UnFormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static updateUnFormalizedZip(
        id: number,
        requestBody: UnFormalizedZipRequestDto,
    ): CancelablePromise<UnFormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/unformalized-zips/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteUnFormalizedZip(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/unformalized-zips/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Получение списка неформализованных zip с фильтрацией
     * @param engineId
     * @param status
     * @param userId
     * @returns UnFormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static findUnFormalizedZips(
        engineId?: number,
        status?: 'NEW' | 'COMPLETED',
        userId?: number,
    ): CancelablePromise<Array<UnFormalizedZipResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/unformalized-zips',
            query: {
                'engineId': engineId,
                'status': status,
                'userId': userId,
            },
        });
    }

    /**
     * @param requestBody
     * @returns UnFormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static createUnFormalizedZip(
        requestBody: UnFormalizedZipRequestDto,
    ): CancelablePromise<UnFormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/unformalized-zips',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
